import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

const GridLayout = ({
  className,
  as = 'div',
  minWidth,
  gap,
  adaptive = false,
  ...props
}) => {
  const Element = as;

  return (
    <Element
      {...props}
      style={{ '--grid-layout-min-width': minWidth, '--grid-layout-gap': gap }}
      className={cn(styles.root, className, { [styles.adaptive]: adaptive })}
    />
  );
};

export default GridLayout;
